import React from 'react';

import { ActivityIndicator, StyleSheet, View } from 'react-native';

import { primitive, spacing } from 'styles/constants';

export const CheckoutV2ExperimentLoading = () => (
  <View style={styles.container} testID="checkout-v2-experiment-loading">
    <ActivityIndicator color={primitive.$bbqBrown} />
  </View>
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    minHeight: 160,
    padding: spacing.$4,
  },
});
